import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { components } from 'react-select';
import { Message } from '../../../primitives/Select/components/Message.js';
export const SelectContainer = ({
  children,
  ...restProps
}) => {
  const {
    selectProps,
    innerProps,
    hasValue
  } = restProps;
  return _jsxs(components.SelectContainer, {
    ...restProps,
    innerProps: {
      ...innerProps,
      // @ts-expect-error FIXME
      'data-testid': selectProps['data-testid']
    },
    children: [children, selectProps.message && _jsx(Message, {
      invalid: selectProps.invalid && !hasValue,
      children: selectProps.message
    })]
  });
};